import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getMedicalFacilitiesAPi, createMedicalFacilitiesAPi,  uploadMedicalFacilitiesAPi, deleteMedicalFacilitiesApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create MedicalFacilities
export const createMedicalFacilities = createAsyncThunk('createMedicalFacilities/MedicalFacilities', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createMedicalFacilitiesAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updateMedicalFacilities = createAsyncThunk('updateMedicalFacilities/MedicalFacilities', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadMedicalFacilitiesAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get MedicalFacilities
export const getMedicalFacilities = createAsyncThunk('getMedicalFacilities/MedicalFacilities', async () => {
    try {
        const response = await axios.get(`${getMedicalFacilitiesAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'MedicalFacilitiess' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete MedicalFacilities
export const deleteMedicalFacilitiess = createAsyncThunk('deleteMedicalFacilitiess/MedicalFacilities', async (MedicalFacilitiesid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteMedicalFacilitiesApi}/${MedicalFacilitiesid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'MedicalFacilitiesid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const MedicalFacilitiesSlice = createSlice({
    name: 'medicalFacilites',
    initialState: {
        MedicalFacilitiess: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create MedicalFacilities
            .addCase(createMedicalFacilities.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createMedicalFacilities.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createMedicalFacilities.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update MedicalFacilities
            .addCase(updateMedicalFacilities.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateMedicalFacilities.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updateMedicalFacilities.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getMedicalFacilitiess
            .addCase(getMedicalFacilities.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getMedicalFacilities.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MedicalFacilitiess = action.payload;
            })
            .addCase(getMedicalFacilities.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete MedicalFacilitiess
            .addCase(deleteMedicalFacilitiess.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteMedicalFacilitiess.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MedicalFacilitiess.data = state.MedicalFacilitiess.data.filter(MedicalFacilitiess => MedicalFacilitiess.MedicalFacilitiesid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteMedicalFacilitiess.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default MedicalFacilitiesSlice.reducer;
